import Web3 from "web3";
import { useWeb3React } from "@web3-react/core";

import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import InputItem from "../Components/UI/InputItem";

import PresaleMasterABI from "../abis/ABI_Master.json";
import ABI_StorageLaunchpad from "../abis/ABI_StorageLaunchpad.json";
import { abi as ABI_ERC20 } from "../abis/ERC20.json";

import { ReactComponent as VerifiedBadge } from "../assets/images/launchpad/verified-badge.svg";
import { ReactComponent as VerifiedChecker } from "../assets/images/launchpad/verified-check.svg";
import { ReactComponent as BinanceCoin } from "../assets/images/launchpad/binance-coin.svg";

import { numberConverter } from "../utils/utils";

import {
    useDeployerContractAddress,
    usePCSRouterV2,
    useStorageContractAddress,
} from "../hooks";
import LinkWithSearchParams from "../Components/UI/LinkWithSearchParams";
import ImageDropZone from "../Components/UI/ImageDropZone";

import { getEllipsisTxt } from "../helpers/formatters";
import { VscLiveShare } from "react-icons/vsc";
import { TbHeart } from "react-icons/tb";
import { RiInformationLine } from "react-icons/ri";
import LoadingBar from "../Components/UI/LoadingBar";
import { setPresaleDetails, uploadToIpfs } from "../utils/apis";

import { showToast } from "../utils/hot-toast";

const CreatePresale = () => {
    const navigate = useNavigate();

    const [, updateState] = useState();
    const forceUpdate = useCallback(() => updateState({}), []);

    const PRESALE_CONTRACT_ADDRESS = useDeployerContractAddress();
    const STORAGE_CONTRACT_ADDRESS = useStorageContractAddress();
    const PCS_ROUTER_V2 = usePCSRouterV2();

    const { active, account, library, chainId } = useWeb3React();

    const [notice, setNotice] = useState("");
    const [presaleLogo, setPresaleLogo] = useState();

    const [auditInputVisible, setAuditInputVisible] = useState(false);
    const [kycInputVisible, setkycInputVisible] = useState(false);

    useEffect(() => {
        if (active === true) {
            window.web3 = new Web3(library.provider);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active]);

    const inputHandler = (e) => {
        if (!e.current) {
            setTimeout(forceUpdate, 100);
        }
        forceUpdate();
    };

    const tokenAddRef = useRef(null);
    const descriptionRef = useRef(null);

    const hardCapRef = useRef(null);
    const liqudityRef = useRef(null);
    // const selectRouterRef = useRef(null);
    const listingRateRef = useRef(null);
    const presaleRateRef = useRef(null);
    const minConRef = useRef(null);
    const maxConRef = useRef(null);
    const preSaleStartRef = useRef(null);
    const preSaleEndRef = useRef(null);
    const liqudityLockTimeRef = useRef(null);

    const auditLinkRef = useRef(null);
    const kycLinkRef = useRef(null);

    const tokensTotalNeeded = () => {
        const tokensForPresale =
            presaleRateRef.current?.value * hardCapRef.current?.value;
        const tokensForPresaleWithExtra =
            tokensForPresale + (tokensForPresale * 2) / 100;
        const tokensForLiquidity =
            (tokensForPresaleWithExtra *
                liqudityRef.current?.innerText.slice(0, -1)) /
            100;
        return tokensForPresaleWithExtra + tokensForLiquidity;
    };

    const checkAllDataForUpload = async () => {
        try {
            if (active) {
                const data = {
                    tokenAddress: tokenAddRef.current.value,

                    hardCap: hardCapRef.current.value,
                    liquidityPercentage: liqudityRef.current.innerText.slice(
                        0,
                        -1
                    ),
                    dexRouter: PCS_ROUTER_V2,
                    listingRate: parseInt(listingRateRef.current.value),
                    presaleRate: parseInt(presaleRateRef.current.value),
                    minContribution: window.web3.utils.toWei(
                        minConRef.current.value.toString(),
                        "ether"
                    ),
                    maxContribution: window.web3.utils.toWei(
                        maxConRef.current.value.toString(),
                        "ether"
                    ),
                    presaleStartTime:
                        new Date(preSaleStartRef.current.value).getTime() /
                        1000,
                    presaleEndTime:
                        new Date(preSaleEndRef.current.value).getTime() / 1000,
                    liquidityLockupTime:
                        new Date(liqudityLockTimeRef.current.value).getTime() /
                        1000,
                };
                if (
                    Object.values(data).find((x) => x === null || x === "") ===
                    undefined
                ) {
                    createPresleContract(data);
                } else {
                    setNotice("Please fill all informations Correct");
                }
            }
        } catch (error) {
            showToast("ERROR", "Please fill all informations Correct");
        }
    };

    const createPresleContract = async (data) => {
        setNotice("Submitting Transaction. Please wait....");

        const web3 = window.web3;
        const _preSaleContract = new web3.eth.Contract(
            PresaleMasterABI,
            PRESALE_CONTRACT_ADDRESS
        );
        const presaleFee = await _preSaleContract.methods.presaleFee().call();
        try {
            await _preSaleContract.methods
                .createNewPresale(
                    data.tokenAddress,
                    data.presaleRate,
                    data.hardCap,
                    data.minContribution,
                    data.maxContribution,
                    data.liquidityPercentage,
                    data.listingRate,
                    data.presaleStartTime,
                    data.presaleEndTime,
                    data.liquidityLockupTime,
                    data.dexRouter
                )
                .send({ from: account, value: presaleFee });

            const _storageContract = new web3.eth.Contract(
                ABI_StorageLaunchpad,
                STORAGE_CONTRACT_ADDRESS
            );
            const tokenContract = new web3.eth.Contract(
                ABI_ERC20,
                data.tokenAddress
            );

            const [_totalProjects, name, symbol, decimals] = await Promise.all([
                _storageContract.methods.getProjectsCount().call(),
                tokenContract.methods.name().call(),
                tokenContract.methods.symbol().call(),
                tokenContract.methods.decimals().call(),
            ]);
            const _presaleAddress = await _storageContract.methods
                .entryListByPresaleAddress(_totalProjects - 1)
                .call();

            //
            const offChainData = JSON.parse(JSON.stringify(data));
            offChainData.chainId = chainId;
            offChainData.name = name;
            offChainData.symbol = symbol;
            offChainData.decimals = decimals;

            offChainData.address = _presaleAddress;
            // offChainData.address = offChainData.tokenAddress;
            offChainData.external_links = [];
            // return;

            if (presaleLogo) {
                setNotice("Uploading Logo to IPFS 🌍...");
                const logo_link = await uploadToIpfs(presaleLogo);
                offChainData.external_links.push({
                    name: "logo",
                    link: logo_link,
                });
            }
            setNotice("Caching presale information to our server 🏢...");
            if (kycInputVisible && kycLinkRef.current?.value)
                offChainData.kycLink = kycLinkRef.current.value;
            if (auditInputVisible && auditLinkRef.current?.value)
                offChainData.auditLink = auditLinkRef.current.value;
            offChainData.owner = account;
            offChainData.description = descriptionRef.current.value;
            await setPresaleDetails(offChainData.address, offChainData);
            setNotice("");
            console.log(_presaleAddress);
            navigate("/manage-presale?detailmodal=true");
        } catch (error) {
            console.log(error.message);
            showToast("ERROR", "Problem while creating presale!");
            setNotice("");
        }
    };

    const createLaunchPadArray = [
        {
            name: "Token Address",
            warning: "*",
            placeholder: "E.G. `0x41d4C8894B529d[50]Eb82A1c183019e388C77d1db`",
            width: "w-full",
            forRef: tokenAddRef,
        },
        {
            name: "Description (Optional)",
            placeholder: "",
            width: "w-full",
            forRef: descriptionRef,
        },
        {
            name: "Hard Cap",
            warning: "*",
            width: "w-full lg:w-[30%]",
            placeholder: "E.G. `100 BNB`",
            forRef: hardCapRef,
        },
        {
            name: "Presale Rate",
            warning: "*",
            width: "w-full lg:w-[30%]",
            placeholder: "E.G. `1,000,000`",
            forRef: presaleRateRef,
        },
        {
            name: "Listing Rate",
            warning: "*",
            width: "w-full lg:w-[30%]",
            placeholder: "E.G. `1,000,000`",
            forRef: listingRateRef,
        },
        {
            name: "Minimum Contribution",
            warning: "*",
            placeholder: "E.G. `0.1 BNB`",
            forRef: minConRef,
        },
        {
            name: "Maximum Contribution",
            warning: "*",
            placeholder: "E.G. `2 BNB`",
            forRef: maxConRef,
        },
        {
            name: "Liquidity%",
            warning: "* - The amount added to liquidity",
            placeholder: "01/01/22",
            select: ["51%", "60%", "70%", "80%", "90%", "100%"],
            initialValue: "70%",
            forRef: liqudityRef,
        },
        {
            name: "Liquidity lock up time",
            warning: "*",
            type: "date",
            forRef: liqudityLockTimeRef,
        },
        // {
        //     name: "Select Router",
        //     select: ["PancakeSwap v2"],
        //     initialValue: "PancakeSwap v2",
        //     forRef: selectRouterRef,
        // },
        {
            name: "Presale Start date",
            warning: "*",
            type: "date",
            forRef: preSaleStartRef,
        },
        {
            name: "Presale End date",
            warning: "*",
            type: "date",
            forRef: preSaleEndRef,
        },
    ];

    return (
        <div className="flex flex-col md:flex-row main-container animation-fade-in relative gap-x-8">
            {notice.length !== 0 && (
                <div className="absolute -left-4 -right-4 top-12 lg:top-20 -bottom-4 backdrop-blur-sm z-[5] flex items-center justify-center">
                    <LoadingBar text={notice} />
                </div>
            )}

            <div className="flex flex-col w-full md:w-[30rem] gap-2">
                <div className="flex flex-col rounded-lg bg-kadItemDarkBg p-6">
                    <span>Live Preview</span>
                    <div className="bg-[#282837] rounded-lg border-2 border-dashed border-[#494949] w-full aspect-square">
                        <ImageDropZone
                            imageObject={presaleLogo}
                            setImageObject={setPresaleLogo}
                        />
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    <a
                        href={`https://bscscan.com/0xc4f65fE1Fe00847B3ac0F5deE6165cb50b64329F`}
                        target="_blank"
                        rel="noreferrer"
                        className="hover:text-kadGrSt duration-150"
                    >
                        {getEllipsisTxt(
                            "0xc4f65fE1Fe00847B3ac0F5deE6165cb50b64329F"
                        )}
                    </a>
                    <a
                        href="https://Kadido.com/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <VerifiedBadge className="hover:opacity-70 duration-150 w-6" />
                    </a>
                    <a
                        href="https://Kadido.com"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <VerifiedChecker className="hover:opacity-70 duration-150 w-[1.4rem]" />
                    </a>
                </div>
                <div className="flex justify-between">
                    <span>Kadena IDO</span>
                    <span className="flex gap-1">
                        <BinanceCoin />
                        {hardCapRef.current?.value} BNB
                    </span>
                </div>

                <div className="flex flex-row items-center z-[2] size-sm">
                    <TbHeart className="size-2 cursor-pointer duration-150 hover:stroke-kadGrSt mr-0.5" />
                    4
                    <VscLiveShare className="size-2 cursor-pointer duration-150 hover:fill-kadGrSt ml-2 mr-auto" />
                    <span>Starts in 11:21:36</span>
                </div>

                <div className="grid grid-cols-3 gap-2 w-full">
                    <div className="rounded-lg flex flex-col items-center bg-kadItemDarkBg py-3">
                        <span className="text-kad-gradient size-sm">
                            Minimum
                        </span>
                        <span>Soft Cap</span>
                        <span className="size-sm font-normal">
                            {hardCapRef.current?.value / 2} BNB
                        </span>
                    </div>
                    <div className="rounded-lg flex flex-col items-center bg-kadItemDarkBg py-3">
                        <span className="text-kad-gradient size-sm">
                            Maximum
                        </span>
                        <span>Hard Cap</span>
                        <span className="size-sm font-normal">
                            {hardCapRef.current?.value} BNB
                        </span>
                    </div>
                    <div className="rounded-lg flex flex-col items-center bg-kadItemDarkBg py-3">
                        <span className="text-kad-gradient size-sm">
                            Tokens
                        </span>
                        <span>For Sale</span>
                        <span className="size-sm font-normal">
                            {numberConverter(
                                hardCapRef.current?.value *
                                    presaleRateRef.current?.value
                            ).replace(" ", "")}{" "}
                            KDI
                        </span>
                    </div>
                    <div className="rounded-lg flex flex-col items-center bg-kadItemDarkBg py-3">
                        <span className="text-kad-gradient size-sm">
                            Tokens
                        </span>
                        <span>For Liquidity</span>
                        <span className="size-sm font-normal">
                            {numberConverter(
                                (hardCapRef.current?.value *
                                    presaleRateRef.current?.value *
                                    liqudityRef.current?.innerText.slice(
                                        0,
                                        -1
                                    )) /
                                    100
                            ).replace(" ", "")}{" "}
                            KDI
                        </span>
                    </div>
                    <div className="rounded-lg flex flex-col items-center bg-kadItemDarkBg py-3">
                        <span className="text-kad-gradient size-sm">
                            Minimum
                        </span>
                        <span>Contribution</span>
                        <span className="size-sm font-normal">
                            {minConRef.current?.value} BNB
                        </span>
                    </div>
                    <div className="rounded-lg flex flex-col items-center bg-kadItemDarkBg py-3">
                        <span className="text-kad-gradient size-sm">
                            Maximum
                        </span>
                        <span>Contribution</span>
                        <span className="size-sm font-normal">
                            {maxConRef.current?.value} BNB
                        </span>
                    </div>
                    <div className="rounded-lg flex flex-col items-center bg-kadItemDarkBg py-3">
                        <span className="text-kad-gradient size-sm">
                            Liquidity
                        </span>
                        <span>Percentage</span>
                        <span className="size-sm font-normal">
                            {liqudityRef.current?.innerText}
                        </span>
                    </div>
                    <div className="rounded-lg flex flex-col items-center bg-kadItemDarkBg py-3 col-span-2">
                        <span className="text-kad-gradient size-sm">
                            Liquidity
                        </span>
                        <span>Unlock Date & Time</span>
                        <span className="size-sm font-normal">
                            {new Date(
                                liqudityLockTimeRef.current?.value
                            ).toLocaleString("en-us")}
                        </span>
                    </div>
                </div>
                <div className="flex flex-col mt-4 font-medium size-sm">
                    <span className="size-base">Note:</span>
                    <span>
                        <font className="font-light text-kadComponentFocus">
                            Setup fee:
                        </font>{" "}
                        250 KDA
                    </span>
                    <span>
                        <font className="font-light text-kadComponentFocus">
                            Service fee:
                        </font>{" "}
                        2% KDA Raised + 1% deposited
                    </span>
                    <span>
                        <font className="font-light text-kadComponentFocus">
                            You will receive:
                        </font>{" "}
                        25.00 KDA $50,000
                    </span>
                </div>
            </div>
            <div className="flex flex-col w-full">
                <div className="flex flex-col md:flex-row justify-between items-end mb-4">
                    <h2>Create Liquidity Launchpad</h2>
                    <LinkWithSearchParams
                        to={{
                            pathname: `/create-launchpad`,
                        }}
                        className="hidden md:block size-sm rounded-full px-2 py-1 font-normal border border-kadComponentBorder hover:bg-kadComponentBorder duration-150"
                    >
                        Switch to private sale
                    </LinkWithSearchParams>
                </div>

                <div className="mb-6">
                    Enter Details
                    <span className="text-kad-gradient"> (*) REQUIRED </span>
                </div>
                <div className="flex flex-wrap items-center justify-between text-left gap-5 mb-6">
                    {createLaunchPadArray.map((el, i) => (
                        <InputItem
                            key={i}
                            {...el}
                            inputHandler={inputHandler}
                        />
                    ))}

                    <div className="flex items-center rounded-lg gap-2 p-3 w-full bg-kadYellow text-[#6E5404]">
                        <RiInformationLine className="size-4" />
                        <div className="flex flex-col">
                            <span>AMOUNT OF TOKENS NEEDED</span>
                            <span className="size-sm">
                                {tokensTotalNeeded()} INCLUDING FEES
                            </span>
                        </div>
                    </div>

                    <div className="flex flex-wrap items-center py-4 px-6 rounded-lg w-full bg-kadItemDarkBg text-kadComponentActive">
                        <div className="flex flex-col">
                            <span className="flex">
                                Upload Audit Report
                                <VerifiedBadge className="w-6 ml-1" />
                                (Optional)
                            </span>
                            <span className="size-sm font-normal">
                                Audit must be from a trusted provider
                            </span>
                        </div>
                        <span className="md:ml-auto mr-2">250 KDA</span>

                        <button
                            onClick={() => {
                                setkycInputVisible(!kycInputVisible);
                            }}
                            className={`${
                                kycInputVisible
                                    ? "bg-[#FC5ED033]"
                                    : "bg-[#A6B2BC4D]"
                            } switch-group`}
                        >
                            <span
                                className={`${
                                    kycInputVisible
                                        ? "translate-x-[20px] bg-kadido-gr"
                                        : "translate-x-[0px] bg-[#A6B2BC]"
                                } switch-thumb`}
                            />
                        </button>
                        {kycInputVisible && (
                            <input
                                className="w-full size-sm pl-6 mt-2 border-none bg-kadDarkBg"
                                placeholder="Enter certificate link"
                                ref={kycLinkRef}
                            />
                        )}
                    </div>
                    <div className="flex flex-wrap items-center py-4 px-6 rounded-lg w-full bg-kadItemDarkBg text-kadComponentActive">
                        <div className="flex flex-col">
                            <span className="flex">
                                Upload KYC Certificate
                                <VerifiedChecker className="w-6 ml-1" />
                                (Optional)
                            </span>
                            <span className="size-sm font-normal">
                                KYC Certificate must be from a trusted provider
                            </span>
                        </div>
                        <span className="md:ml-auto mr-2">250 KDA</span>

                        <button
                            onClick={() => {
                                setAuditInputVisible(!auditInputVisible);
                            }}
                            className={`${
                                auditInputVisible
                                    ? "bg-[#FC5ED033]"
                                    : "bg-[#A6B2BC4D]"
                            } switch-group`}
                        >
                            <span
                                className={`${
                                    auditInputVisible
                                        ? "translate-x-[20px] bg-kadido-gr"
                                        : "translate-x-[0px] bg-[#A6B2BC]"
                                } switch-thumb`}
                            />
                        </button>
                        {auditInputVisible && (
                            <input
                                className="w-full size-sm pl-6 mt-2 border-none bg-kadDarkBg"
                                placeholder="Enter certificate link"
                                ref={auditLinkRef}
                            />
                        )}
                    </div>
                </div>
                <div className="flex flex-col-reverse md:flex-row items-center">
                    {active ? (
                        <button
                            className="blueGradient-button rounded-lg w-full md:w-[48%]"
                            onClick={checkAllDataForUpload}
                        >
                            Next
                        </button>
                    ) : (
                        <button
                            className="blueGradient-button rounded-lg w-full md:w-[48%]"
                            disabled={true}
                        >
                            Please Connect Wallect
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
export default CreatePresale;
